<template>
	<b-modal
		:visible="value"
		scrollable
		no-fade
		ok-only
		:ok-title="this.$t('quote.assign')"
		:title="this.$t('quote.title')"
		id="modal-form-quote"
		size="xl"
		body-class="position-static"
		hide-footer
		no-close-on-backdrop
		@close="exit()"
		@show="showed"
		@hide="hidded"
		>

		<form>
			<!-- header & currency -->
			<b-row class="mb-3">
				<b-col>
					<div class="rounded bg-light-alt py-2 px-3">
						<b-row>
							<b-col lg="6">
								<p class="m-0 mr-2 mt-1">
									<span class="mr-2">{{ this.$t('quote.reservation') }}</span>
									<span v-if="viewModel.id ===-1"><strong>{{ this.$t('quote.newQuote') }}</strong></span>
									<span v-else><strong>#{{viewModel.id}} </strong></span>
								</p>
							</b-col>

							<b-col lg="4" class="ml-auto">
								<b-form-group label-cols="4" label-size="sm" :label="this.$t('quote.currency')" label-for="input-sm" class="mb-0">
									<b-form-select :options="currenciesOpts" size="sm" v-model="formModel.currency" ></b-form-select>
								</b-form-group>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
			<!-- /header & currency -->

			<!-- travel type / pickup / dropoff -->
			<b-row>
				<b-col xl="3">
					<b-form-group :label="this.$t('quote.tripType')">
						<b-form-select :options="categoryRidesOpts"  v-model="categoryRide"></b-form-select>
					</b-form-group>
				</b-col>

				<b-col xl="4" lg="5">
					<b-form-group :label="this.$t('bookings.pickup')">
						<vue-typeahead-bootstrap
							required
							v-model="pickup.search"
							class="input-fix typeahead"
							ref="pickupField"
							show-all-results
							:placeholder="this.$t('global.search')"
							:serializer="(place) => place.name"
							:data="pickup.data"
							@keyup="searchPlace('pickup',pickup.search)"
							@hit="(selected) => setPlace('pickup', selected)"
						>
							<template #suggestion="{ data, htmlText }">
								<md-icon icon="flight" v-if="data.isAirport"/>
								<md-icon icon="place" v-else/>
								<span v-html="htmlText"></span><br /><small>{{
								data.address
								}}</small>
							</template>
							<template #prepend>
								<b-input-group-text>
									<b-spinner v-if="pickup.loading" small />
									<span v-else>
										<md-icon :icon="iconFrom"/>
									</span>
								</b-input-group-text>
							</template>
						</vue-typeahead-bootstrap>
					</b-form-group>
				</b-col>

				<b-col class="col-auto px-md-0 pt-lg-4 py-2 mx-auto">
					<b-form-checkbox v-model="a2bWayBoolean" name="check-button" button size="sm" button-variant="success" @change="swapPlaces()">
							<md-icon :icon="'swap_horiz'"/>
					</b-form-checkbox>
				</b-col>

				<b-col xl="4" lg="5">
					<b-form-group :label="this.$t('bookings.dropoff')">
						<vue-typeahead-bootstrap
							required
							v-model="dropoff.search"
							class="input-fix typeahead"
							ref="dropoffField"
							show-all-results
							:placeholder="this.$t('global.search')"
							:serializer="(place) => place.name"
							:data="dropoff.data"
							@keyup="searchPlace('dropoff',dropoff.search)"
							@hit="(selected) => setPlace('dropoff', selected)"
						>
							<template #suggestion="{ data, htmlText }">
								<md-icon icon="flight" v-if="data.isAirport"/>
								<md-icon icon="place" v-else/>
								<span v-html="htmlText"></span><br /><small>{{
								data.address
								}}</small>
							</template>
							<template #prepend>
								<b-input-group-text>
									<b-spinner v-if="dropoff.loading" small />
									<span v-else>
										<md-icon :icon="iconTo"/>
									</span>
								</b-input-group-text>
							</template>
						</vue-typeahead-bootstrap>
					</b-form-group>
				</b-col>
			</b-row>
			<!-- /travel type / pickup / dropoff -->

			<!-- dates / pax / btn -->
			<b-row>
				<b-col class="col-auto">
					<b-form-group label="Roundtrip?" class="text-center">
						<b-form-checkbox v-model="formModel.roundTrip" name="check-button" switch></b-form-checkbox>
					</b-form-group>
				</b-col>
				<b-col xl="3" lg="5">
					<b-form-group :label="this.$t('quote.oneWay')">
						<b-form-datepicker
							aria-required="true"
							v-model="formModel.serviceDate"
							required
							size=""
							class="mb-1"
							locale="es"
							reset-button
							close-button
							:date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
						/>
					</b-form-group>
				</b-col>
				<b-col xl="3" lg="5">
					<b-form-group :label="this.$t('quote.return')" :disabled="!formModel.roundTrip">
						<b-form-datepicker
						v-model="formModel.returnServiceDate"
						locale="es"
						reset-button
						close-button
						:date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
						/>
					</b-form-group>
				</b-col>

				<b-col xl="3" lg="10">
					<b-row>
						<b-form-group :label="this.$t('bookings.adults')" class="col-md-4">
							<b-form-select  v-model="formModel.adults" :disabled="paxDisabled">
								<b-form-select-option v-for="(item, i) in 20" :value="i" :key="i" >{{i}}</b-form-select-option>
							</b-form-select>
						</b-form-group>
						<b-form-group :label="this.$t('bookings.kids')" class="col-md-4">
							<b-form-select  v-model="formModel.children" :disabled="paxDisabled">
								<b-form-select-option v-for="(item, i) in 20" :value="i" :key="i">{{i}}</b-form-select-option>
							</b-form-select>
						</b-form-group>
						<b-form-group :label="this.$t('bookings.infants')" class="col-md-4">
							<b-form-select  v-model="formModel.infants" :disabled="paxDisabled">
								<b-form-select-option v-for="(item, i) in 20" :value="i" :key="i">{{i}}</b-form-select-option>
							</b-form-select>
						</b-form-group>
					</b-row>
				</b-col>
				<b-col class="col-auto pt-md-4 py-2">
					<b-button variant="primary" @click="searchPrices" :class="(hasChangedSinceLastSearch)?'shake':''"> <md-icon v-if="hasChangedSinceLastSearch"  icon="refresh"/>
						{{ this.$t('global.search') }}</b-button>
				</b-col>
			</b-row>
			<!-- /dates / pax / btn -->
		</form>

		<!-- todo: ask about this! -->
		<div style="min-height:25rem">
			<section v-if="!offer.show">
				<Skeleton v-if="loading"></Skeleton>
				<b-row v-else >
					<b-col lg="6" v-for="(service,_i) in services" :key="_i" class="mb-2">
						<card-service
							:currency="formModel.currency"
							:ticket="ticket"
							:shuttle="service"
							@rateSelected="rateSelectedAction"
							@rateSelectedOffer="showOfferForm"
						/>
					</b-col>
					<b-col lg="6" class="mx-auto mt-3" v-if="noResults">
						<b-alert show variant="warning">
							<h4 class="alert-heading">Ups!</h4>
							<p>Tu busqueda no arrojó resultados</p>
						</b-alert>
					</b-col>
				</b-row>
			</section>
		</div>
	</b-modal>
</template>

<script>
import api from '../../../../api.js'
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import debounce from "debounce";
import CardService from "./helpers/CardService";
import { mapMutations, mapState } from "vuex";
import moment from 'moment';
import Skeleton from '../../../helpers/Skeleton';

export default {
	components: {
		VueTypeaheadBootstrap,
		CardService,
		Skeleton
	},
	props: {
		value: Boolean
	},
	data() {
		const iconsConfigByCategory = {
			apto: {a2b: 'flight', b2a: "place"},
			p2p: {a2b: 'place', b2a: "place"}
		}

		const placeModelDefault = {
			address: "",
			airportIata: "",
			isAirport: false,
			latitude: "",
			longitude: "",
			name: ""

		}

		const formModelDefault = {
			lang: "es",
			pointOfSaleId: this.$root.store.state.currentSystem.system.id,
			currency: null,
			adults: 1,
			children: 0,
			infants: 0,
			roundTrip: false,
			pickup: {...placeModelDefault},
			dropoff: {...placeModelDefault},
			serviceDate: '',
			returnServiceDate: '',
			tripType: '',
			searchType: '',
		}

		return {
			categoryRide: "apto",
			a2bWayBoolean: true,
			iconsConfigByCategory: iconsConfigByCategory,
			formModel: {...formModelDefault},
			formModelSubmitted: {...formModelDefault},
			pickup: {
				search: '',
				data: [],
				loading: false
			},
			dropoff: {
				search: '',
				data: [],
				loading: false
			},
			services: [],
			noResults: false,
			currenciesList: [],
			loading: false,
			rateSelected: {},
			lastReservationId: -1,
			offer: {
				show: false,
				applied: false,
				originalRate: {},//rate selected original
				formData: {}//el formulario con el nuevo precio
			}
		}
	},
	methods: {
		...mapMutations("reservation", ["SET_NEW_MODEL", "SET_RESET_MODEL", "ADD_TRANSPORT_SERVICE", "SET_UPDATE_TRANSPORT_SERVICE", "SET_UPDATE_QUOTE_PROPS"]),
		exit() {
			this.$emit("input", false);
		},
		swapPlaces() {
			let _aux = {
				pickup: {...this.formModel.dropoff},
				dropoff: {...this.formModel.pickup}
			}
			Object.assign(this.formModel, _aux)
			this.pickup.search = this.formModel.pickup.name;
			this.dropoff.search = this.formModel.dropoff.name;

		},
		searchPlace: debounce(function (attrName, term) {
			if (term !== '') {
				this[`${attrName}`].data = [];
				this[`${attrName}`].loading = true;
				api(this).get(`quote/places/search`, {params: {term}}).then((res) => {
					this[`${attrName}`].data = res.data;
					//this[`${attrName}Loading`] = false;
				})
					.catch((err) => {
						console.log(err);
					})
					.finally(() => {
						this[`${attrName}`].loading = false;
					})
			}
		}, 500),
		async setPlace(type, selected) {
			let infoSelectec = {...selected};
			if (selected.ref !== '') {
				// busca los detalles del objeto
				infoSelectec = (await api(this).get(`quote/places/${selected.ref}`)).data;
				this[`${type}`].data = [{...infoSelectec}];
				this.formModel[`${type}`] = infoSelectec;
			} else {
				this[`${type}`].search = '';
				this[`${type}`].data = [];
				return;
			}
		},
		searchPrices() {
			if (this.validate()) {
				this.resetOfferFields();
				this.loading = true
				this.services = [];

				this.formModel.tripType = this.formModel.roundTrip ? 'roundtrip' : 'oneway'
				if(this.categoryRide == 'apto') {
					this.formModel.searchType = this.a2bWayBoolean ? 'A2H' : 'H2A'
				} else {
					this.formModel.searchType = 'P2P'
				}

				this.formModelSubmitted = {...this.formModel};
				api(this)
					.get(`quote/prices`, {params: this.formModel})
					.then((res) => {
						if (Array.isArray(res.data)) {
							this.services = res.data;
						}

						if(this.services.length > 0)
							this.noResults = false
						else
							this.noResults = true

					})
					.finally(() => {
						this.loading = false;
					})
			}
		},
		getSettingPointOfSale() {
			api(this).get(`point-of-sales/${this.formModel.pointOfSaleId}`).then((res) => {
				this.currenciesList = res.data.settingVars.currencies
				this.formModel.currency = this.currenciesList[0] ?? null;
				//this[`${attrName}Loading`] = false;
			});
		},
		validate() {
			try {
				if (this.isEmpty(this.formModel.currency)) {
					throw this.$t('quote.currencyReq')
				}
				if (this.isEmpty(this.formModel.pickup.ref)) {
					throw this.$t('quote.pickupReq')
				}
				if (this.isEmpty(this.formModel.dropoff.ref)) {
					throw this.$t('quote.dropoffReq')
				}

				if (this.isEmpty(this.categoryRide)) {
					throw this.$t('quote.serviceTypeReq')
				}
				if (this.isEmpty(this.formModel.serviceDate)) {
					throw this.$t('quote.dateGoToReq')
				}
				if (this.formModel.roundTrip && this.isEmpty(this.formModel.returnServiceDate)) {
					throw this.$t('quote.dateGoBackReq')
				}
				if (this.isEmpty(this.formModel.adults)) {
					throw this.$t('quote.adultsReq')
				}

			} catch (err) {
				this.$root.showAlert(err, {variant: 'danger'})
				return false;
			}
			return true;
		},
		isEmpty(val) {
			return (val === null || val === undefined || val === "");
		},
		getTsForReservation() {
			let qtyServices = (this.formModelSubmitted.roundTrip) ? 2 : 1;
			//-----------
			// Sacamos el id de los places
			//-----------
			let infoPickup = this.formModelSubmitted.pickup.ref.split("-");
			let pickupId = parseInt(infoPickup[1])
			let pickupType = infoPickup[0]
			let infoDropoff = this.formModelSubmitted.dropoff.ref.split("-");
			let dropoffId = parseInt(infoDropoff[1])
			let dropoffType = infoDropoff[0]
			//-----------
			//-----------
			let transportServices = [];
			for (let _a = 0; _a < qtyServices; _a++) {
				let ts = {};
				let pickupPlace = {...this.formModelSubmitted.pickup, ...{id: pickupId, type: pickupType}};
				let dropoffPlace = {...this.formModelSubmitted.dropoff, ...{id: dropoffId, type: dropoffType}};
				switch (_a) {
					case 0://ida
						ts.pickup = {...pickupPlace};
						ts.dropoff = {...dropoffPlace};
						ts.pickupPlaceId = ts.pickup.id
						ts.dropoffPlaceId = ts.dropoff.id;
						ts.flightDatetime = this.formModelSubmitted.serviceDate + " 00:00:00"
						ts.pickupDatetime = this.formModelSubmitted.serviceDate + " 00:00:00"
						break;
					case 1://regreso
						ts.pickup = {...dropoffPlace};
						ts.dropoff = {...pickupPlace};
						ts.pickupPlaceId = ts.pickup.id
						ts.dropoffPlaceId = ts.dropoff.id;
						ts.flightDatetime = this.formModelSubmitted.returnServiceDate + " 00:00:00"
						ts.pickupDatetime = this.formModelSubmitted.returnServiceDate + " 00:00:00"
						break;
				}
				ts.fromQuote = true;
				let totalOriginal = (this.offer.applied) ? this.offer.originalRate[this.ticket] : this.rateSelected[this.ticket];
				ts.quote = {
					ratePlanId: this.rateSelected.ratePlanId,
					bookingPriceTotal: this.rateSelected[this.ticket] / qtyServices,
					bookingPriceTotalOriginal: totalOriginal / qtyServices,
					bookingCurrency: this.rateSelected.currency,
					ticket: this.ticket,
					specialRate: this.offer.applied,
					specialRateData: this.offer.formData
				};


				// ts.salesChannelId = this.rateSelected.salesChannelId
				ts.ratePlanInfo = this.rateSelected.ratePlanInfo // used by rateplans != sc
				ts.serviceTypeId = this.rateSelected.serviceType.id
				ts.ratePlanType		 = this.rateSelected.ratePlanType
				ts.serviceTypeName   = this.rateSelected.serviceType.name
				ts.pointOfSaleId = this.formModelSubmitted.pointOfSaleId
				ts.status = "pending"
				transportServices.push(ts);
			}

			if (this.viewModel.id === -1) {//es una reserva nueva

				if (this.formModelSubmitted.roundTrip) {
					this.ADD_TRANSPORT_SERVICE();
				}
				transportServices.forEach((dataTs, _indexTs) => {
					let payload = {
						index: _indexTs,
						data: dataTs
					}
					this.SET_UPDATE_TRANSPORT_SERVICE(payload);
				})
			} else if (this.viewModel.id > 0) {
				transportServices.forEach((dataTs) => {
					this.ADD_TRANSPORT_SERVICE();
					let totalServices = this.viewModel.transportServices.length;
					let _indexTs = (totalServices - 1);
					dataTs.salesChannelReference = this.viewModel.id + "-" + (totalServices);
					let payload = {
						index: _indexTs,
						data: dataTs
					}
					this.SET_UPDATE_TRANSPORT_SERVICE(payload);
				})
			}
			return transportServices;
		},
		rateSelectedAction(rateSelected) {
			this.resetOfferFields();
			this.rateSelected = rateSelected;
			this._processData();

		},
		_processData() {//la logica
			if (this.viewModel.id === -1) {//si es uno nuevo se resetea el modelo de reservas
				this.SET_RESET_MODEL();
				let aux = {...this.viewModel};
				aux.adults = this.formModelSubmitted.adults;
				aux.children = this.formModelSubmitted.children;
				aux.infants = this.formModelSubmitted.infants;
				this.SET_NEW_MODEL(aux)

			}

			this.getTsForReservation();
			this.$root.$emit(
				"bv::show::modal",
				"modal-reservations",
				event.target
			);
			this.$emit("input", false);
		},
		showOfferForm(rateSelected) {
			this.offer.show = true;
			this.offer.originalRate = {...rateSelected};
		},
		applyOfferAction({originalRate, customRate, formData: offerFormData}) {
			this.resetOfferFields();
			this.offer.applied = true;//bandera para saber que aplicó precio especial
			this.offer.formData = {...offerFormData}
			this.offer.originalRate = {...originalRate};
			this.rateSelected = {...customRate}
			this._processData();
		},
		showed() {
			if (this.lastReservationId !== this.viewModel.id) {
				this.reset()
			}
			if (this.viewModel.id > 0) {
				this.formModel.adults = this.viewModel.adults
				this.formModel.children = this.viewModel.children
				this.formModel.infants = this.viewModel.infants
			}
			if (process.env.NODE_ENV === "development") {//para pruebas mas rapidas
				this.formModel.pickup = {
					"ref": "scplace-3665",
					"name": "Terminal 4 Aeropuerto Internacional de Cancun",
					"address": "Benito Juárez, Quintana Roo, Mexico",
					"isAirport": true,
					"latitude": "21.04676300",
					"longitude": "-86.87979330",
					"airportIata": "CUN"
				}
				this.pickup.search = this.formModel.pickup.name
				this.formModel.dropoff = {
					"ref": "scplace-812",
					"name": "Hard Rock Hotel Cancun",
					"address": "Blvd. Kukulcan 14.5, Zona Hotelera, 77500 Cancún, Q.R., Mexico",
					"isAirport": false,
					"latitude": "21.08970250",
					"longitude": "-86.77088810",
					"airportIata": null
				}
				this.dropoff.search = this.formModel.dropoff.name
				this.formModel.serviceDate = moment().format("YYYY-MM-DD");
			}

		},
		hidded() {
			this.lastReservationId = this.viewModel.id;
			this.SET_UPDATE_QUOTE_PROPS({showForm: false})
		},
		reset() {
			Object.assign(this.$data, this.$options.data.apply(this))
			this.getSettingPointOfSale()
		},
		resetOfferFields() {
			this.offer.show = false;//ocultaos modulo
			this.offer.applied = false;//bandera para saber que aplicó precio especial
			this.offer.originalRate = {};//reset
			this.offer.formData = {};//reset
			return true
		}

	},
	computed: {
		...mapState("reservation", ["viewModel", "quote"]),

		categoryRidesOpts() {
			return [
				{text: this.$t('quote.airportTransp'), value: 'apto'},
				{text: this.$t('quote.p2p'), value: 'p2p'},
			];
		},
		a2bWayCode() {
			return (this.a2bWayBoolean) ? "a2b" : "b2a";
		},
		a2bWayCodeInverted() {
			return (!this.a2bWayBoolean) ? "a2b" : "b2a";
		},
		iconFrom() {
			return this.iconsConfigByCategory[this.categoryRide][this.a2bWayCode]
		},
		iconTo() {
			return this.iconsConfigByCategory[this.categoryRide][this.a2bWayCodeInverted]
		},
		ticket() {
			return (this.formModelSubmitted.roundTrip) ? "roundtrip" : "oneway"
		},
		currenciesOpts() {
			let opts = [{value: null, text: this.$t('notifications.selectOption')}];
			this.currenciesList.forEach((val) => {
				let item = {value: val, text: val}
				opts.push(item);
			})
			return opts;
		},
		paxDisabled() {
			return (this.viewModel.id > 0)
		},
		hasChangedSinceLastSearch() {
			return (JSON.stringify(this.formModel) !== JSON.stringify(this.formModelSubmitted) && this.services.length > 0)
		}
	},
	watch: {},
	mounted() {
		this.getSettingPointOfSale()
	},

}
</script>
<style scoped>
.bg-light-alt {
	background-color: #e9ecef !important;
	color: #6c757d !important;
}

/* Animation property */
.shake {
  animation: wiggle 2s linear infinite;
}
/* Keyframes */
@keyframes wiggle {
  0%, 7% {
	transform: rotateZ(0);
  }
  15% {
	transform: rotateZ(-15deg);
  }
  20% {
	transform: rotateZ(10deg);
  }
  25% {
	transform: rotateZ(-10deg);
  }
  30% {
	transform: rotateZ(6deg);
  }
  35% {
	transform: rotateZ(-4deg);
  }
  40%, 100% {
	transform: rotateZ(0);
  }
}
</style>
